import React  from 'react'
import BlogMenuItem from "./BlogMenuItem"

export default function BlogMenuList({menus}) {
  return (
    <div className="list_order">
      { menus.map((item, index) =>
        <BlogMenuItem key={index} index={index} item={item} />
      )}
    </div>
  )
}
